import { Column, Row } from '@bfa/common-ui';
import { externalRedirect } from '@bfa/nextjs-common/utils';
import get from 'lodash/get';
import React, { useEffect } from 'react';

import Layout from '../../../components/Layout';
import { ABSOLUTE_URLS } from '../../../constants';
import { logAnalyticsEvent } from '../../../utils/analytics';
import { AnalyticsEventKey } from '../../../utils/analytics/constants';
import Popup from '../components/Popup';
import useGetAlert from './hooks/useGetAlert';

const ReferralGift = () => {
  const { data } = useGetAlert({ alertId: 'referral-gift' });
  const analyticsKey: AnalyticsEventKey = 'REFERRAL_GIFT';
  const alert = get(data, 'me.alert');

  useEffect(() => {
    logAnalyticsEvent({
      name: analyticsKey,
      label: 'Viewed Referral Gift Interstitial',
    });
  }, [analyticsKey]);

  const trackConfirm = () => {
    logAnalyticsEvent({ name: analyticsKey, label: 'Clicked Yes Please' });
  };
  const trackDismiss = () => {
    logAnalyticsEvent({ name: analyticsKey, label: 'Clicked Dismiss' });
  };
  return (
    <Layout
      header={{
        minimum: true,
        cross: true,
        onCrossClick: () => {
          trackDismiss();
          externalRedirect(ABSOLUTE_URLS.GLAM_BAG);
        },
        onLogoClick: () => {
          trackDismiss();
        },
      }}
      footer={false}
    >
      <Row marginTop="3rem">
        <Column xs={12} xsOffset={0} sm={8} smOffset={2} md={6} mdOffset={3}>
          <Popup
            {...alert}
            primaryActionOnClick={() => {
              trackConfirm();
            }}
            secondaryActionOnClick={() => {
              trackDismiss();
            }}
          />
        </Column>
      </Row>
    </Layout>
  );
};

export default ReferralGift;
